export const ColorColumns = [
    "CRMColor",
    "PDFColor",
    "PONumber",
    "Style",
    "SNo"
  ]